import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { motion } from "framer-motion";
import { ArrowLeft, Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("bf_token", data.token);
      nav("/admin/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <div className="grain-overlay" />
      <div className="max-w-[1600px] w-full mx-auto px-5 md:px-10 py-8">
        <button
          data-testid="back-home"
          onClick={() => nav("/")}
          className="flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground hover:text-primary transition-colors"
        >
          <ArrowLeft size={14} /> Back to site
        </button>
      </div>
      <div className="flex-1 flex items-center justify-center px-5 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="w-full max-w-md border border-border bg-card p-8 md:p-12"
        >
          <div className="w-12 h-12 bg-primary flex items-center justify-center mb-8">
            <Lock size={20} className="text-primary-foreground" />
          </div>
          <span className="text-xs font-mono uppercase tracking-[0.3em] text-muted-foreground">/ Client Portal</span>
          <h1 className="font-display font-black text-3xl md:text-4xl tracking-tighter uppercase mt-4 mb-10">Admin Access</h1>

          <form data-testid="login-form" onSubmit={submit} className="space-y-7">
            <label className="block">
              <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-muted-foreground">Email</span>
              <input
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border-b border-border focus:border-primary py-3 mt-1 font-mono text-sm outline-none transition-colors"
                placeholder="management@biofleetcouriers.com"
              />
            </label>
            <label className="block">
              <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-muted-foreground">Password</span>
              <input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-transparent border-b border-border focus:border-primary py-3 mt-1 font-mono text-sm outline-none transition-colors"
                placeholder="••••••••"
              />
            </label>

            {error && (
              <p data-testid="login-error" className="text-xs font-mono text-destructive">{error}</p>
            )}

            <button
              data-testid="login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-primary text-primary-foreground font-mono uppercase tracking-[0.15em] text-xs font-bold py-4 border border-primary hover:bg-transparent hover:text-primary transition-colors duration-300 disabled:opacity-50"
            >
              {loading ? "Authenticating..." : "Sign In"}
            </button>
          </form>
        </motion.div>
      </div>
    </div>
  );
}
